import { render, staticRenderFns } from "./ModuleContent.vue?vue&type=template&id=734f6dcc&scoped=true&"
import script from "./ModuleContent.vue?vue&type=script&lang=js&"
export * from "./ModuleContent.vue?vue&type=script&lang=js&"
import style0 from "./ModuleContent.vue?vue&type=style&index=0&id=734f6dcc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734f6dcc",
  null
  
)

export default component.exports